// El origen canónico del sitio. UNA sola vez, en todo el repo.
//
// POR QUÉ existe este fichero: había cuatro constantes `SITE` independientes
// (scripts/seo-emit.mjs, scripts/blog-html.mjs, src/components/SEOHead.tsx,
// src/components/seo/JsonLd.tsx) y las cuatro decían "https://workloop.us".
// Pero el ápex no sirve el sitio: en Vercel `workloop.us` está configurado con
// `redirect: www.workloop.us`, y quien responde 200 es `www`. El resultado era
// que cada página servida declaraba como canónica una URL que devuelve un 307,
// y lo mismo hacían el sitemap, los hreflang, el JSON-LD, el RSS y llms.txt.
// Un canonical que apunta a un redirect no se respeta: Google elige por su
// cuenta y las señales no se consolidan en ninguna de las dos URLs.
//
// Se alinea el repo con la infraestructura, y no al revés, porque invertir el
// redirect (hacer canónico el ápex) es un cambio en la configuración de
// dominios de producción de Vercel: ningún PR puede hacerlo ni verificarlo.
//
// Es .js y no .ts a propósito: lo importan tanto los componentes de React
// (vía el alias `@/`) como los emisores de SEO en `scripts/*.mjs`, que corren
// en Node puro y no entienden TypeScript. Un solo fichero para los dos mundos
// es lo único que impide que vuelvan a divergir.
//
// Sin barra final. Todo el que lo use concatena rutas que empiezan por "/".
//
// Nota sobre stage: stage.workloop.us sirve este mismo build y por tanto
// declara canónicos de producción. Es deliberado — stage no debe competir en
// el índice con las URLs reales.
export const SITE = "https://www.workloop.us";

// El host sin esquema. Lo necesitan los sitios estáticos y los checks.
export const SITE_HOST = "www.workloop.us";
